export const toTitleCase = (str: string | undefined) => {
  if (!str) {
    return '';
  }

  return str.toLowerCase().replace(/\b\w/g, str => str.toUpperCase());
};
